export const CATEGORIES = [
  { label: 'Música', value: 'musica' },
  { label: 'Teatro', value: 'teatro' },
  { label: 'Esportes', value: 'esportes' },
  { label: 'Palestras', value: 'palestras' },
  { label: 'Festival', value: 'festival' },
  { label: 'Encontros', value: 'encontros' },
  { label: 'Gastronomia', value: 'gastronomia' },
  { label: 'Infantil', value: 'infantil' },
  { label: 'Cultura', value: 'cultura' },
  { label: 'Outros', value: 'outros' },
];

// { musica: 'Música', teatro: 'Teatro', ... }
export const CATEGORY_LABELS = Object.fromEntries(
  CATEGORIES.map(({ value, label }) => [value, label])
);

// ['musica', 'teatro', ...]
export const CATEGORY_VALUES = CATEGORIES.map(({ value }) => value);
